import { Injectable } from '@angular/core';

/* It's a wrapper around the native localStorage API that allows you to store and
retrieve data as JSON */
export class LocalStorage {
  setItem(key: string, data: any) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  getItem<T = any>(key: string) {
    const storedData = localStorage.getItem(key) as string;

    try {
      return JSON.parse(storedData) as T;
    } catch (error) {
      return undefined;
    }
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}

/* It's a wrapper around the sessionStorage API that allows you to store and
retrieve data as JSON */
export class SessionStorage {
  setItem(key: string, data: any) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getItem<T = any>(key: string) {
    const storedData = sessionStorage.getItem(key) as string;

    try {
      return JSON.parse(storedData) as T;
    } catch (error) {
      return undefined;
    }
  }

  removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}

@Injectable({
  providedIn: 'root',
})
export class PersistenceService {
  public session = new SessionStorage();
  public local = new LocalStorage();
}
